/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import CardHeader from '../../../../../components/CardHeader'
import UpdateButton from '../../../../../components/UpdateButton'
import Toast from '../../../../../components/Toast'
import Input from '../../../../../components/InputBox'
import moment from 'moment'
import { dataService } from '../../../../../services/data.services'
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId'
import { useNavigate, useSearchParams } from 'react-router-dom'
import GlobalContext from '../../../../../components/Context/GloablContext'
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt'
import ConfirmationModel from '../../../../../components/ConfirmationModel';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel'
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick'
import DropDownComponent from '../../../../StudentMaster/Directory/Components/AddStudentComponents/DropDownComponent'
import WarningMessage from '../../../../../components/WarningMessage'
import { useSelector } from 'react-redux'
import FeeStructureDropdown from '../../../../../components/FeeStructureDropdown'
import StudentListPopup from './StudentListPopup'
import SearchItemField from '../../../PurchaseOrder/Components/AddPurchaseOrder/SearchItemField'
import CustomOverLay from '../../../../../components/CustomOverlay';
import { DatePicker } from 'antd'
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import Debounce from '../../../../../CommonMethods/Debounce'
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate';
import { ShimmerTitle } from 'react-shimmer-effects'
import CustomeDatePicker from '../../../../../components/DatePicker'
import InvoiceErrorModal from './InvoiceErrorModal'
import InvoiceScheduledModal from './InvoiceScheduledModal'

dayjs.extend(customParseFormat);

export default function IssueInventory({type}) {
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const {setToastmessage, reloadFY, setReloadFY} = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [isUnique, setIsUnique] = useState(true)
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const [bulkIssuePopUp, setBulkIssuePopUp] = useState(false)
    const [remainingCount, setRemainingCount] = useState(0)
    const [transactionId, setTransactionId] = useState()
    const [classLoading, setClassLoading] = useState(false);
    const [sectionLoading, setSectionLoading] = useState(false)
    const [academicLoading, setAcademicLoading] = useState(false);
    const navigate = useNavigate();
    const [dateError, setdateError] = useState("");
    const currentDate = moment();
    let formattedDate = '';
    const fy = JSON.parse(localStorage.getItem('FY_details'));
    const fy_start_date = new Date(fy.start_date);
    const fy_end_date = new Date(fy.end_date);
    const feeHeadFields = { fee_head_name: '', fee_head_id: '', amount: '' };
    const [feeHeadRows, setFeeHeadRows] = useState([feeHeadFields]);
    if ((currentDate >= fy_start_date && currentDate <= fy_end_date)) {
        formattedDate = currentDate.format('MMM DD,YYYY');
    }
    const initialState = {
        grn_date: formattedDate,
        vendor_invoice : "",
        receiver_type : "student",
        financial_year: `${JSON.parse(localStorage.getItem('FY_details'))?.name} (${JSON.parse(localStorage.getItem('FY_details'))?.status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details'))?.status.slice(1)})`,
        academic_year: {
            name: "",
            start_date: "",
            end_date: ""
        },
        class:"",
        sections:"",
        student_name:"",
        student_id : "",
        invoice_type: type === "student-master" ? "fee" :"inventory",
        invoice_amount : "",
        fee_head_name : "",
        fee_head_id: '',
        date : "",
        class_id : "",
        section_id : "",
        student_uuid:""
        
    }
    const newFields = {item_name: '', item_code: '', uom :"" ,inventory_id: "", po_quantity : "", rcvd_quantity : "", bal_quantity: "",cost_per_item: "",total_cost : ""}
    const [newStateFields, setNewStateFields] = useState([newFields]);
    const [state, setState] = useState(initialState) 
    const [studentDoa, setStudentDoa] = useState()
    const [warningMessage, setWarningMessage] = useState('')
    const [feeHeadList, setFeeHeadList] = useState([])
    //Ledger Field is removed therefore it is commented.
    // const [ledgerList, setLedgerList] = useState([])
    const [loadingPage, setLoadingPage] = useState(true)
    const [selectedClassSearch, setSelectedClassSearch] = useState("")
    const [sections,setSections]=useState([])
    const [submitSelected, setsubmitSelected] = useState(false);
    const [qtyError, setqtyError] = useState(false);
    const [showDropdown, setshowDropdown] = useState({
        blood_group: false,
        gender: false,
        economic_status: false,
        religion: false,
        caste_category: false,
        academic_year: false,
        class: false,
        section: false,
    });
    const [selectedSearchStudent,setSelectedSearchStudent]=useState('')
    const inputRef=useRef()
    const [studentDropdownData,setStudentDropdownData]=useState([])
    const [showStudentsDropdownData,setShowStudentDropdownData]=useState(false)
    const [studentSearchStarted,setStudentSearchStarted]=useState(false)
    const [showClassStudentsDropdownData,setShowClassStudentDropdownData]=useState(false)
    const [studentAllData, setStudentAllData] = useState([])
    const [studentListLoading, setstudentListLoading] = useState(false)
    const [studentIdArray, setStudentIdArray] = useState([])
    const [invoiceDateFilter, setInvoiceDateFilter] = useState(
        formattedDate ? moment(formattedDate, "MMM DD,YYYY").format("YYYY-MM-DD") : ""
    )
    const [viewStudentList, setViewStudentList] = useState(false)
    const [selectedErrorState, setSelectedErrorState] = useState(null)
    const {userType} = useSelector((state)=>state.auth);
    const [radioBtnChange, SetRadioBtnChange] = useState(false)
    const [totalStudents, setTotalStudents] = useState()
    const [invoiceErrorModalOpen, setInvoiceErrorModalOpen] = useState(false);
    const [invoiceErrorList, setInvoiceErrorList] = useState([]);
    const [invoiceValidStudents, setInvoiceValidStudents] = useState([]);
    const [invoiceScheduledModalOpen, setInvoiceScheduledModalOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const hasAutoResolvedInitialAyRef = useRef(false);
    const selectedInvoiceDateRef = useRef(
        formattedDate ? moment(formattedDate, "MMM DD,YYYY").format("YYYY-MM-DD") : ""
    );
    const hasUserSelectedInvoiceDateRef = useRef(false);
    /**
     * The function `handleValidations` checks for empty fields based on certain conditions and returns
     * a boolean value indicating if there are any empty fields.
     * @returns a boolean value. If the count is not equal to 0, it means there are empty fields and it
     * will return true. Otherwise, it will return undefined.
     */
    const handleValidations = () => {
        let count = 0
        let nonEmptyFieldStudent = [ "student_name", "academic_year","grn_date"]
        let nonEmptyFieldClass = [ "academic_year","grn_date", "class"]
        if(state.invoice_type !== "inventory") {
            nonEmptyFieldStudent = [ "student_name", "academic_year","grn_date"]
            nonEmptyFieldClass = [ "academic_year","grn_date", "class"]
        }
        const validateArray = state.receiver_type === "student" ? nonEmptyFieldStudent : nonEmptyFieldClass
        validateArray.map((item) => {
            if (item === "academic_year") {
                // Check each part of the academic_year object
                if (state.academic_year.name === "" || state.academic_year.start_date === "" || state.academic_year.end_date === "") {
                    count += 1;
                }
            } else if (state[item] === "" || state[item] === null) {
                count += 1;
            }
        });
        if(state.invoice_type === "inventory") {
            const fields = ["item_name", "rcvd_quantity", "cost_per_item", "item_code"]
            newStateFields.forEach((item) => {
                fields.forEach((field) => {
                    if (item[field]?.trim() === "") {
                        count++;
                    }
                });
            });
        }
        else{
            const fields = ["fee_head_name", "amount"]
            feeHeadRows.forEach((item) => {
                fields.forEach((field) => {
                    if (item[field]?.trim() === "") {
                        count++;
                    }
                });
            });
        }
        
        return count !== 0
    }
    /**
     * The `handleSubmit` function is used to handle the submission of a form, perform validations,
     * extract data from the form fields, and make an API request to create an invoice in an inventory
     * management system.
     * @returns The function `handleSubmit` does not have a return statement.
     */
    const handleSubmit = async() => {
        setWarningMessage("")

        if(!(userType==='institution-user' || userType==='institution-admin')) {
            const branch_id = await GetBranchId()
            const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing&sort=status%2Basc`, true);
            if(res.data.data.ongoing !== JSON.parse(localStorage.getItem('FY_details')).name) {
                setToastErrorMessage(`You are not authorized to make entry for the${JSON.parse(localStorage.getItem('FY_details')).name}. Please refresh the page.`)
                return
            }
        }
        if(openConfirmation) {
            setActivateButtonLoading(true)
        } else {
            setLoading(true)
        }
        if(handleValidations()){
            setsubmitSelected(true)
            setToastErrorMessage("Please fill in all the mandatory fields")
            setLoading(false)
            setOpenConfirmation(false)
            setActivateButtonLoading(false)
            return
        } else if(studentAllData?.length === 0 && state.receiver_type === "class") {
            setToastErrorMessage('No students available in the selected Class/Section');
            setLoading(false)
            setOpenConfirmation(false)
            setActivateButtonLoading(false)
            return;
        }else {
            if (state.invoice_type === "inventory") {
                // Validate if received quantity exceeds PO quantity
                const exceededQuantityItems = newStateFields.filter(item => parseFloat(item.rcvd_quantity) > parseFloat(item.po_quantity));

                if (exceededQuantityItems.length > 0) {
                    setqtyError(true)
                    setsubmitSelected(true)
                    setToastErrorMessage(`Issue Qty cannot exceed Stock Qty`);
                    setLoading(false);
                    setOpenConfirmation(false);
                    setActivateButtonLoading(false);
                    return;
                }
            }   
            try {
                
                let body = {
                    branch_id: await GetBranchId(),
                    financial_year: JSON.parse(localStorage.getItem('FY_details')).name,
                    invoice_type: state.invoice_type,
                    receiver_type: state.receiver_type,
                    academic_year: state.academic_year.name,
                    academic_year_id: state.academic_year.academic_year_id,
                    class_name: state.class,
                    date: (new Date(new Date(state.grn_date).getTime() + (5.5 * 60 * 60 * 1000))).toDateString(), // Adding 5.5 hours
                    class_id: state.class_id,
                    validation: isUnique,
                    invoice_name: state.invoice_name ? state.invoice_name :(state.invoice_type === "fee" ? `Fee` : `Inventory`)
                };
                
                if (state.section_id !== "" && state.section_id !== null) { 
                    body["section_id"] = state.section_id;
                    body["section_name"] = state.sections
                }
                if(state.invoice_type === "inventory") {

                    const keysToExtract = [
                        "item_name",
                        "item_code",
                        "inventory_id",
                        "uom",
                        "available_quantity",
                        "quantity",
                        "price_per_item",
                        "total_cost"
                    ];

                    const extractedArray = newStateFields.map(item => {
                        const extractedItem = {};
                        keysToExtract.forEach(key => {
                            if(key === "available_quantity") {
                                extractedItem[key] = item["po_quantity"];
                            } else if(key === "quantity") {
                                extractedItem[key] = item["rcvd_quantity"];
                                // if(state.receiver_type !== "student" && studentIdArray?.length > parseInt(item["rcvd_quantity"])) {
                                //     setToastErrorMessage("Insufficient items for students allocation")
                                //     return
                                // }
                            } else if(key === "price_per_item") {
                                extractedItem[key] = item["cost_per_item"];
                            } else {
                                extractedItem[key] = item[key];
                            }
                        });
                        return extractedItem;
                    });  
                    body["items"] = extractedArray,
                    body["invoice_total"] = newStateFields.reduce((acc, item) => acc + (parseFloat(item.total_cost) || 0), 0).toFixed(2)
                } else {
                    body["fee_heads"] = feeHeadRows,
                    body["invoice_total"] = feeHeadRows.reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0).toFixed(2)
                }
                if(state.receiver_type === "student") {
                    body["students"] = [
                        {
                            "student_name": state.student_name,
                            "student_id": state.student_id,
                            "section_id" : state.section_id,
                            "section_name" : state.sections,
                            'student_uuid': state.student_uuid

                        }
                    ]
                } else {
                    let result = [];

                    studentAllData.forEach(item => {
                        if (studentIdArray.includes(item.student_id)) {
                            result.push({
                                "student_name": item.full_name.trim(),
                                "student_id": item.student_id,
                                "section_id" : item?.sections.section_id,
                                "section_name" : item?.sections.section_name,
                                'student_uuid': item?._id

                            });
                        }
                    });
                    body["students"] = result                
                }
                let response = null
                response = await dataService.PostAPI(body, 'invoice');
                setOpenConfirmation(false)
                setActivateButtonLoading(false)
                const params = Object.fromEntries(searchParams);

                if (type === "student-master") {
                    if (state.receiver_type === "class") {
                        const updatedParams = {
                            ...params,
                            transactionId: response?.data.data?.transactionId,
                            totalStudents: response?.data.data?.totalStudents,
                            isScheduleModal: true,
                        };
                        setSearchParams(updatedParams);
                        navigate(
                            `/student-master/invoice-list?${new URLSearchParams(
                                updatedParams
                            ).toString()}`
                        );
                    } else {
                        navigate("/student-master/invoice-list");
                    }
                } else {
                    navigate("/inventory-master/inventory-list");
                }

                setToastmessage(response?.data.data?.message);
                
                setLoading(false)
            } catch (error) {
                // console.log("sjdnkjnsfsdufhuyfrfr",studentAllData.length - error?.response?.data?.errors.length)
                if (state.receiver_type === "class" && error?.response?.data?.message === "One or more students failed validation.") {
                    setRemainingCount(studentIdArray?.length - error?.response?.data?.errors.length);
                    setInvoiceErrorList(error?.response?.data?.errors);
                    setInvoiceValidStudents(Array(90).fill({})); // 90 dummy valid students
                    setInvoiceErrorModalOpen(true);
                    setIsUnique(false)
                } else {
                    setToastErrorMessage(error?.response?.data?.message || "Something went wrong");  
                }
                setOpenConfirmation(false)
                setActivateButtonLoading(false)
                setLoading(false);
                
            }
        }
    }

    /**
     * The handleInput function updates the state object with the new value of the input field based on
     * its id.
     */
    const handleInput = (e) => {
        let {id,value}=e.target        
        setState((prv)=>({
            ...prv,
            [id]:value
        }))
        
    }

    const fetchStudentAYRelationByDate = useCallback(async (selectedDateValue, studentUuid = state.student_uuid) => {
        if (!studentUuid) {
            return null;
        }

        const branch_id = await GetBranchId();
        const targetDate = selectedDateValue.format("YYYY-MM-DD");

        try {
            const endpoint = `students/student-ay-relation-by-date?branch_id=${branch_id}&student_id=${studentUuid}&date=${targetDate}`;
            const response = await dataService.GetAPI(endpoint, true);
            const relation = response?.data?.data?.data;
            if (relation?.academic_year?.name) {
                return relation;
            }
        } catch (error) {
            if (error?.response?.status !== 404) {
                throw error;
            }
        }

        return null;
    }, [state.student_uuid]);

    /**
     * The function `handleSelectedDate` checks if a selected date is within a specified range and
     * updates the state accordingly, or throws an error if the date is outside the range.
     */
    const handleSelectedDate = async (id, date, dateString, studentContext = null, isExplicitDateSelection = false) => {
        console.log("Selected date:", date, "Date string:", dateString);
        let selectedDate = moment(dateString, ["MMM DD, YYYY", "YYYY-MM-DD"], true);
        if (!selectedDate.isValid() && date) {
            selectedDate = moment(date);
        }
        if (!selectedDate.isValid()) {
            setToastErrorMessage("Invalid invoice date selected.");
            selectedInvoiceDateRef.current = "";
            hasUserSelectedInvoiceDateRef.current = false;
            setInvoiceDateFilter("")
            return;
        }
        selectedDate = selectedDate.startOf('day');
        selectedInvoiceDateRef.current = selectedDate.format("YYYY-MM-DD");
        if (isExplicitDateSelection) {
            hasUserSelectedInvoiceDateRef.current = true;
        }

        const fyDetails = JSON.parse(localStorage.getItem('FY_details'));
        const startDate = moment(fyDetails.start_date).startOf('day');
        const fyEndDate = moment(fyDetails.end_date).endOf('day');
        const todayEnd = moment().endOf('day');
        const endDate = fyEndDate.isBefore(todayEnd) ? fyEndDate : todayEnd;
        const effectiveStudentId = studentContext?.studentId ?? state.student_id;
        const effectiveStudentUuid = studentContext?.studentUuid ?? state.student_uuid;
        const doa = moment(studentContext?.doa ?? studentDoa).startOf('day');

        if (!(selectedDate.isSameOrAfter(startDate) && selectedDate.isSameOrBefore(endDate))) {
            selectedInvoiceDateRef.current = "";
            hasUserSelectedInvoiceDateRef.current = false;
            setInvoiceDateFilter("")
            setState((prev) => ({
                ...prev,
                grn_date: null,
                academic_year: {
                    name: "",
                    start_date: "",
                    end_date: "",
                },
                class_id: "",
                section_id: "",
                class: "",
                sections: "",
            }));
            setToastErrorMessage(`Invoice Date (${selectedDate.format('MMM DD, YYYY')}) must be within ${state.financial_year}`);
            return;
        }

        setInvoiceDateFilter(selectedDate.format("YYYY-MM-DD"))
        setState((prev) => ({
            ...prev,
            grn_date: date,
        }));

        if (state.receiver_type === "student" && effectiveStudentId !== "" && effectiveStudentId !== null) {
            if (selectedDate.isBefore(doa, "day")) {
                setToastErrorMessage(
                    `Invoice Date cannot be prior to student’s Date of Admission ${doa.format(
                        "DD MMM YYYY"
                    )}.`
                );
                selectedInvoiceDateRef.current = "";
                hasUserSelectedInvoiceDateRef.current = false;
                setInvoiceDateFilter("")
                setState((prev) => ({
                    ...prev,
                    grn_date: null,
                }));
                return;
            }
            const selectedAY = await fetchStudentAYRelationByDate(selectedDate, effectiveStudentUuid);

            if (selectedAY?.academic_year?.name) {
                setState((prev) => ({
                    ...prev,
                    grn_date: date,
                    academic_year: {
                        name: selectedAY.academic_year.name,
                        start_date: selectedAY.academic_year.start_date,
                        end_date: selectedAY.academic_year.end_date,
                        academic_year_id: selectedAY.academic_year_id,
                    },
                    class_id: selectedAY.class_id,
                    section_id: selectedAY.section_id,
                    class: selectedAY.class_name,
                    sections: selectedAY.section_name,
                }));
            } else {
                setState((prev) => ({
                    ...prev,
                    grn_date: date,
                    academic_year: {
                        name: "",
                        start_date: "",
                        end_date: "",
                    },
                    class_id: "",
                    section_id: "",
                    class: "",
                    sections: "",
                }));
                setToastErrorMessage("No matching academic year found for the selected date.");
                return;
            }
        }
    };

    const handleInvoiceDateSelection = useCallback((id, date, dateString) => {
        handleSelectedDate(id, date, dateString, null, true);
    }, [handleSelectedDate]);

    //Ledger Field is removed therefore it is commented.
    // const handleDropDownValue = (key, value, index) => {
    //     const exist_value = value
    //     const updatedClassFields = [...newStateFields];
      
    //     if(key === "ledger") {
    //         updatedClassFields[index]["ledger"] = value
    //     } else {
    //         updatedClassFields[index]["item_name"] = ""
    //         updatedClassFields[index]["item_code"] = ""
    //         updatedClassFields[index]["uom"] = ""
    //         updatedClassFields[index]["quantity"] = ""
    //         updatedClassFields[index]["cost_price"] = ""
    //         updatedClassFields[index]["total_price"] = ""
    //         const itemExists = updatedClassFields.some(field => field.item_code === exist_value.item_code);
    //         if(itemExists) {
    //             setToastErrorMessage('Item code already exists. Try another');
    //             return
    //         }
    //         updatedClassFields[index]["item_name"] = exist_value.item_name
    //         updatedClassFields[index]["item_code"] = exist_value.item_code
    //         updatedClassFields[index]["uom"] = exist_value.uom
    //         updatedClassFields[index]["quantity"] = exist_value.quantity
    //         updatedClassFields[index]["cost_price"] = exist_value.cost_price
    //         updatedClassFields[index]["total_price"] = exist_value.total_price
    //     }
    //     setNewStateFields([...updatedClassFields])
    //     handleDropdown(key);

    // };

    /**
     * The function `handleDropdown` toggles the visibility of a dropdown menu and resets an error
     * message and submit status.
     */
    const handleDropdown = (key) => {
        setToastErrorMessage('')
        setsubmitSelected(false);
        setqtyError(false)
        setshowDropdown((prv) => ({
            ...prv,
            [key]: !showDropdown[key],
        }));
    };

    /**
     * The function `handleRemoveClassField` removes a class field from the state array based on the
     * provided index.
     */
    const handleRemoveClassField = (indexToRemove) => {
        setToastErrorMessage('')
        setWarningMessage("")
        setsubmitSelected(false)
        setqtyError(false)
        setToastErrorMessage('')
        const updatedClassFields = newStateFields.filter((_, index) => index !== indexToRemove);
        setNewStateFields([...updatedClassFields]);
    };

    /**
     * The function `handleAddClassField` adds a new field to an array and displays a warning message
     * if the array length reaches 19.
     */
    const handleAddClassField = () => {
        setsubmitSelected(false)
        setqtyError(false)
        setWarningMessage("")
        setToastErrorMessage('')
        const updatedClassFields = [
            ...newStateFields,
            newFields,
        ];
        setNewStateFields([...updatedClassFields]);

        if (newStateFields?.length === 19)  {
            setToastErrorMessage('')
            setWarningMessage("Items")
        }
    };

    /**
     * The `handleFieldChange` function is used to handle changes in input fields, perform validations,
     * and update the state accordingly.
     * @returns The function does not explicitly return anything.
     */
    const handleFieldChange = (index, name, value) => {
        setToastErrorMessage("")
        setWarningMessage("");
        // Remove any non-numeric and non-dot characters
        const inputValue = name === "rcvd_quantity" ? value.replace(/[^\d]/g, '') :  value.replace(/[^\d.]/g, '');
        const updatedClassFields = [...newStateFields];
        if(name === "rcvd_quantity") {
            if(Number(value) > Number(newStateFields[index]["po_quantity"])) {
                // updatedClassFields[index]["bal_quantity"] = ""
                // updatedClassFields[index][name] = "";
                setToastErrorMessage(`${newStateFields[index]['item_name']} [${newStateFields[index]['item_code']}]: Issue Qty cannot exceed Stock Qty ${newStateFields[index]["po_quantity"]}. Adjust accordingly`);
                updatedClassFields[index]["bal_quantity"] = newStateFields[index]["po_quantity"] - inputValue
                updatedClassFields[index]["total_cost"] = (Number(inputValue) * Number(newStateFields[index]["cost_per_item"])).toFixed(2)
                updatedClassFields[index][name] = inputValue;
            } else {
                updatedClassFields[index]["bal_quantity"] = newStateFields[index]["po_quantity"] - inputValue
                updatedClassFields[index]["total_cost"] = (Number(inputValue) * Number(newStateFields[index]["cost_per_item"])).toFixed(2)
                updatedClassFields[index][name] = inputValue;
            }
         
        } else {
            if(parseFloat(value) > parseFloat(newStateFields[index]["cost_per_item"])) {
                // updatedClassFields[index][name] = "";
                // updatedClassFields[index]["total_cost"] = ""
                setToastErrorMessage(`Cost cannot exceed ${inputValue} Rs. Please adjust it to ${newStateFields[index]["cost_per_item"]} Rs or less`);
                return
            } else {
                if (inputValue?.length <= 13 ) {
                // Allow only up to 2 decimal places
                    const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
                    if (regex.test(inputValue)) {
                        updatedClassFields[index][name] = inputValue;
                        updatedClassFields[index]["total_cost"] = inputValue * newStateFields[index]["po_quantity"]
                    }
                }
            } 
            // Limit to a maximum length of 5 characters (including decimal and decimals)
            
        }
        setNewStateFields([...updatedClassFields]); 
    }


    //Ledger Field is removed therefore it is commented.
    // const getLedger = async() => {
    //     const branch_id = await GetBranchId()
    //     const res= await dataService.GetAPI(`groups-and-ledgers?branch_id=${branch_id}&type=ledger&search=Income > Direct Income&status=active&filter=true&list_ledger=true`);
    //     setLedgerList(res?.data?.data?.data?.map(item => item.parent_group_name_composite_key));
    // }

    /**
     * The function `getFeeHeadList` retrieves a list of fee heads from an API based on the branch ID
     * and sets the fee head list in the component state.
     */
    const getFeeHeadList = async() => {
        const branch_id = await GetBranchId()
        const res= await dataService.GetAPI(`feehead?branch_id=${branch_id}&sort=created_at%2Basc&status=true&filter=true&role=invoices`, true);
        setFeeHeadList(res?.data?.data?.data)
    }

    /* The above code is a useEffect hook in a React component. It is used to perform certain actions
    when the component mounts or when the value of the "reloadFY" variable changes. */
    useEffect(() => {
        const fetchData = async () => {
            // Assuming getFeeHeadList and getAcademicyears are async functions
            try{
                setLoadingPage(true)
                await getFeeHeadList();
                // await getAcademicyears();
                // await getClasses();
    
                setTimeout(() => {
                    const FY_details = JSON.parse(localStorage.getItem('FY_details'));
                    const financial_year = `${FY_details.name} (${FY_details.status.charAt(0).toUpperCase() + FY_details.status.slice(1)})`;
                    const today = moment();
        
                    setState(prevState => ({
                        ...prevState,
                        financial_year
                    }));

                    if (today.isBefore(moment(FY_details.start_date)) || today.isAfter(moment(FY_details.end_date))) {
                        setToastErrorMessage(`Invoice Date (${today.format('MMM DD, YYYY')}) must be within ${financial_year}`);
                    }
        
                    setLoadingPage(false); // Set loading to false after timeout
                }, 1000); // 2000 ms = 2 seconds
        
            } catch (error) {
                console.log(error);
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
                setLoadingPage(false); // Set loading to false in case of error
            }
        };
        fetchData();
        if(reloadFY) {
            setLoadingPage(true)
            setState(initialState)
            setSelectedSearchStudent("");
            setNewStateFields([newFields])
            setFeeHeadRows([feeHeadFields])
            setReloadFY(false)
            setsubmitSelected(false)
            setqtyError(false)
            setTimeout(() => {
                setLoadingPage(false)
            }, 500);
        }
    },[reloadFY])

    /**
     * The function `handleStudentSearch` is used to search for students or classes based on a given
     * search value and update the dropdown data accordingly.
     */
    const handleStudentSearch = async(search, type) => { 
        setsubmitSelected(false)
        setStudentSearchStarted(true)
        setShowStudentDropdownData(false)
        setStudentDropdownData([])
        setqtyError(false)
        setToastErrorMessage("")
        setState((prv)=>({
            ...prv,
            sections:'',
            section_id:''
        }))
        setStudentAllData([])
        setStudentIdArray([])
        setstudentListLoading(true)
        let searchValue = encodeURIComponent(search).replace(/[#&]/g, '\\$&').trim()
        if(searchValue.trim() !== "") {
            setTimeout(async() => {
                const branch_id = await GetBranchId();
                let response = null
                if(type === "student") {
                    response = await dataService.GetAPI(`students?filter=true&status=active&branch_id=${branch_id}&search=${searchValue}&is_academic_year=true&role=invoices`, true);
                    setShowStudentDropdownData(true)
                    
                } else {
                    response = await dataService.GetAPI(`classes?branch_id=${branch_id}&filter=true&status=true&search=${searchValue}&role=invoices`, true);
                    if(response?.data?.data?.data?.length > 0){
                        setShowClassStudentDropdownData(true)
                    }
                }
                setStudentDropdownData(type === "student" ? response?.data?.data?.students : response?.data?.data?.data)
            }, 700);
        } else{
            setStudentDropdownData([])
            setShowStudentDropdownData(false)
            setShowClassStudentDropdownData(false)
            setStudentSearchStarted(false)
        }
    }

    /* The above code is using the `useOnClickOutside` hook in a React component. */
    const [outSideClickTriggered, setOutSideClickTriggered] = useState(false)
    useOnClickOutside(inputRef,()=>{
        if(state.student_name !== "") {
            setSelectedSearchStudent(`${state.student_name} (${state.student_id})`)
        }
        setStudentDropdownData([])
        setShowStudentDropdownData(false)
        setShowClassStudentDropdownData(false)
        setStudentSearchStarted(false)
        setOutSideClickTriggered((prev) => !prev)
    })

    const [academicYear, setAcademicYear] = useState([]);
    const [classes, setClasses] = useState([]);

    /**
     * The function `getAcademicyears` retrieves ongoing and upcoming academic years based on the
     * branch ID and sets the result to the state variable `AcademicYear`.
     */
    const getAcademicyears = async () => {
        setAcademicLoading(true)
        const branch_id = await GetBranchId()
        let endpoint = `academic-years?filter=true&branch_id=${branch_id}&status=ongoing,upcoming&role=invoices`
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        setAcademicYear(temp)
        setAcademicLoading(false);
    }

    /**
     * The function `getClasses` makes an asynchronous API call to retrieve classes data and sets the
     * retrieved data to the `classes` state variable.
     */
    const getClasses = async () => {
        setClassLoading(true)
        const branch_id = await GetBranchId()
        let endpoint = `classes?branch_id=${branch_id}&filter=true&status=true&role=invoices`
        const response = await dataService.GetAPI(endpoint);
        const temp = (response.data?.data?.data);
        setClasses(temp || [])
        setClassLoading(false);
    }

    /**
     * The function `handleCheckBox` is used to update the state based on the key-value pair provided,
     * with special handling for certain keys.
     */
    const handleCheckBox = async(key, value) => {
        if(key === "receiver_type" || key === "invoice_type") {
            let updatedState = initialState
            if(key === "receiver_type") {
                updatedState["receiver_type"] = state.receiver_type
                updatedState["invoice_type"] = state.invoice_type
            }
            if(key === "invoice_type") {
                updatedState["invoice_type"] = state.invoice_type
            }
            updatedState[key] = value
            setState(updatedState)
            setNewStateFields([newFields])
            setSelectedClassSearch("");
            setSelectedSearchStudent("");
            setToastErrorMessage("");
            setsubmitSelected(false);
            setqtyError(false)
            setStudentAllData([])
            setstudentListLoading(true)
            setShowStudentDropdownData(false)
            setShowClassStudentDropdownData(false)
            await getAcademicyears();
            await getClasses();
        }else if(key === "fee_head_name") {
            setsubmitSelected(false)
            setqtyError(false)
            setToastErrorMessage(false)
            setState((prv) => ({
                ...prv,
                [key]: value.name,
                fee_head_id: value._id,
            }));
        } else {
            setState((prv) => ({
                ...prv,
                [key]: value,
            }));
        }
    }

    /**
     * The function `handleOnchangeInput` updates the state based on the selected options and sets the
     * `submitSelected` flag to false.
     */
    const handleOnchangeInput = (id, option) => {
        setsubmitSelected(false);
        setqtyError(false)
        if(id === "academic_year") {
            if(state.academic_year.name !== option.name) {
                setState((prv) => ({
                    ...prv,
                    "academic_year": {
                        "name": option.name,
                        "start_date": option.start_date,
                        "end_date": option.end_date,
                        "academic_year_id": option._id,
                    },
                    "class":"",
                    "sections":""
                    
                }));
                setSelectedClassSearch("")
            }
        } else if(id==="class_name"){
            setState((prv) => ({
                ...prv,
                "class":option.name,
                "class_id" : option._id,
                "sections":"",
            }));
        }
        else if(id==="section"){
            setState((prv)=>({
                ...prv,
                "sections":option.name,
                "section_id" : option.id
            }))
        }
    }

    const callSectionAPI = useCallback(async () => {
        setSectionLoading(true)
        if (state.academic_year.name !== "" && state.class !== "") {
            setstudentListLoading(true)
            const branch_id = await GetBranchId();
            let endpoint = `associations?branch_id=${branch_id}&academic_year_id=${state.academic_year.academic_year_id}&class_id=${state.class_id}&filter=true&role=invoices`;
            const response = await dataService.GetAPI(endpoint, true);
            const temp = response.data?.data?.data;
            setSections(
                temp.map((obj) => {
                    return {
                        name: obj.section_name,
                        id: obj.section_id,
                        subjects: obj.subjects,
                    };
                })
            );
        }
        setSectionLoading(false); 
    }, [state.academic_year.name, state.class]);

    /* The above code is defining a function called `getStudentListWithFilter` using the `useCallback`
    hook in React. This function is an asynchronous function that performs the following tasks: */
    const getStudentListWithFilter = useCallback(async () => {
        if (state.academic_year.name !== "" && state.class !== "" && state.receiver_type === "class") {
            const branch_id = await GetBranchId();
            const invoiceDate = invoiceDateFilter
                ? `&invoice_date=${encodeURIComponent(invoiceDateFilter)}`
                : '';
            const response = await dataService.GetAPI(`students?filter=true&status=active&branch_id=${branch_id}&class_id=${state.class_id}${state.sections !== "" ? `&section_id=${state.section_id}` : ''}&academic_year_id=${state.academic_year.academic_year_id}&is_academic_year=true&role=invoices&relation_date_filter=true${invoiceDate}`, true);
            setStudentAllData(response?.data?.data?.students)
            setStudentIdArray(response?.data?.data?.students.map(obj => obj.student_id))
            setstudentListLoading(false)
        }
    }, [state.academic_year.name, state.class, state.sections, invoiceDateFilter]);

    /* The above code is using the useEffect hook in React to call two functions, callSectionAPI and
    getStudentListWithFilter, when the component is mounted or when the dependencies (callSectionAPI
    and getStudentListWithFilter) change. */
    useEffect(() => {
        callSectionAPI();
        getStudentListWithFilter();
    }, [callSectionAPI, state?.class_id, getStudentListWithFilter]);

    useEffect(() => {
        if (
            !hasAutoResolvedInitialAyRef.current
            && state.receiver_type === "student"
            && state.student_uuid !== ""
            && selectedInvoiceDateRef.current
            && state.academic_year.name === ""
        ) {
            hasAutoResolvedInitialAyRef.current = true;
            handleSelectedDate(
                "grn_date",
                dayjs(selectedInvoiceDateRef.current, "YYYY-MM-DD"),
                selectedInvoiceDateRef.current
            );
        }
    }, [state.receiver_type, state.student_uuid, state.grn_date, state.academic_year.name, invoiceDateFilter]);

    /**
     * The function `handleSearchField` updates the fields of an item in an array if the item code does
     * not already exist in the array, otherwise it displays an error message.
     */
    const handleSearchFiled = (index, items) => {
        const itemCode = items.item_code;
        setSelectedErrorState(null);
        setToastErrorMessage("")
        const updatedClassFields = [...newStateFields];
        updatedClassFields[index]["item_code"] = "";
        updatedClassFields[index]["uom"] = "";
        updatedClassFields[index]["item_name"] = "";
        // Check if the item_code already exists in newStateFields
        const itemExists = updatedClassFields.some(field => field.inventory_id === items._id);
        if (itemExists) {
            // You can throw an error or handle it as you see fit. For example:
            // setError('Item with this code already exists in the list.');
            // return; // Stop further processing
    
            // For this example, I'm setSelectedFilter(item)logging an error message
            setSelectedErrorState(index)
            setToastErrorMessage("Duplicate Entry: Item '"+items.item_name+" ["+items.item_code+"]'"+" is already added");
            updatedClassFields[index]["po_quantity"] = '';
            updatedClassFields[index]["rcvd_quantity"] = '';
            updatedClassFields[index]["cost_per_item"] = '';
            updatedClassFields[index]["total_cost"] = '';
        } 
        else if(Number(items.total_available_quantity) == 0){
            setToastErrorMessage("Item '"+items.item_name+" ["+items.item_code+"]'"+' is currently out of stock');
            updatedClassFields[index]["po_quantity"] = '';
            updatedClassFields[index]["rcvd_quantity"] = '';
            updatedClassFields[index]["cost_per_item"] = '';
            updatedClassFields[index]["total_cost"] = '';
        }
        else {
            // Item does not exist, so you can proceed to update the fields
            const updatedClassFields = [...newStateFields];
            updatedClassFields[index]["item_code"] = items.item_code;
            updatedClassFields[index]["uom"] = items.uom;
            updatedClassFields[index]["inventory_id"] = items._id;
            updatedClassFields[index]["item_name"] = items.item_name;
            updatedClassFields[index]["po_quantity"] = items.total_available_quantity;
            updatedClassFields[index]["rcvd_quantity"] = '1';
            updatedClassFields[index]["cost_per_item"] = items.selling_price.toString();
            updatedClassFields[index]["total_cost"] = items.selling_price * 1;

        }
        setNewStateFields(updatedClassFields);

    };

    /**
     * The function `handelOpenFY` sets the `activateButtonLoading` state to `false` and the
     * `openConfirmation` state to `true`.
     */
    const handelOpenFY = async() => {
        setActivateButtonLoading(false)
        setOpenConfirmation(true)
    }

    const disabledFutureDate = (current) => {
        // Disable dates that are after the current date
        return current && current > moment().endOf('day');
    };

    /**
     * The function `handleInvoiceAmountChange` is used to handle changes in the invoice amount input
     * field, allowing only up to 2 decimal places and updating the state with the new value if it
     * passes the validation.
     */
    const handleInvoiceAmountChange = (inputValue) => {
        if (inputValue?.length <= 13 ) {
            // Allow only up to 2 decimal places
            const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
            if (regex.test(inputValue)) {
                setState((prv) => ({
                    ...prv,
                    "invoice_amount" : inputValue
                }));
            }
        }
    }
    /* The above code is using the `useCallback` hook in React to create a memoized version of the
    `Debounce` function. The `Debounce` function is a utility function that delays the execution of
    a given function until a certain amount of time has passed without any further calls to the
    function. */
    const handleStudentSearchParams = useCallback(
        Debounce((value, type) => handleStudentSearch(value, type)),
        []
    );

    const clearIfValueIsZero = (index, name) => (e) => {
        if (Number(e.target.value) === 0) {
            handleFeeAmountChange(index, name, '');
        }
    };

    const setZeroIfEmpty = (index, name) => (e) => {
        let value = e.target.value;
        if (value.trim() === '') {
            value = '0.00';
        } else {
            value = parseFloat(value).toFixed(2);
        }
        handleFeeAmountChange(index, name, value);
    };

    const handleFeeAmountChange = (index, name, value) => {
        const updated = [...feeHeadRows];
        const inputValue = value.replace(/[^\d.]/g, '');
        // Only allow numbers and up to 2 decimals
        if (inputValue?.length <= 13) {
            // Allow only up to 2 decimal places
            const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
            if (regex.test(inputValue)) {
                updated[index].amount = inputValue;
            }
        }
        
        setFeeHeadRows(updated);
    };

    useEffect(() => {
        const updatedState = { ...state };
        updatedState["invoice_name"] = updatedState["invoice_type"] === "fee" ? `Fee` : `Inventory`;
        setState(updatedState);
    }, [state.invoice_type]);

    useEffect(() => {
        const studentName = searchParams.get("student_name");
        const studentId = searchParams.get("student_id");
        const studentUuid = searchParams.get("student_uuid");
        const doa = searchParams.get("doa");
        const url = searchParams.get("redirect_url")

        if (studentName && studentId) {
            hasAutoResolvedInitialAyRef.current = false;
            if (invoiceDateFilter || formattedDate) {
                selectedInvoiceDateRef.current = invoiceDateFilter
                    || moment(formattedDate, "MMM DD,YYYY").format("YYYY-MM-DD");
                hasUserSelectedInvoiceDateRef.current = true;
            }
            setState((prev) => ({
                ...prev,
                student_name: studentName,
                student_id: studentId,
                student_uuid: studentUuid,
                academic_year: {
                    name: "",
                    start_date: "",
                    end_date: "",
                },
                class: "",
                class_id: "",
                sections: "",
                section_id: "",
            }));
            setStudentDoa(doa);
            setSelectedSearchStudent(`${studentName} (${studentId})`);
            setRedirectUrl(url);
        }
    }, [formattedDate, invoiceDateFilter, searchParams,state.receiver_type,state.invoice_type])

    return (
        <CardHeader noPadding>
            <div class="mainDataCntnrTop shadow-s13" style={{position: "sticky", position: "-webkit-sticky"}}>
                <h5 class="pageHeader addclass">Issue Invoice</h5>
                <div class="flex items-center handleStudentSearchParams">
                    <UpdateButton
                        ButtonName={"Cancel"}
                        loading={false}
                        handleOnCLick={() => {navigate(searchParams.get("isFromDirectory") ? redirectUrl : type === "student-master" ? '/student-master/invoice-list' : "/inventory-master/inventory-list")}}
                        classKey="cancl-btn"
                    />
                    <UpdateButton
                        loading={loading}
                        ButtonName={"Approve"}
                        width={'106px'}
                        handleOnCLick={() => {( JSON.parse(localStorage.getItem('FY_details')).status === "open" )? handelOpenFY() : handleSubmit()}}
                        classKey={"actn-btn onboardInstitution"}
                    />
                </div>
                {toastErrorMessage!=='' &&<Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
                {warningMessage !== "" && <WarningMessage 
                    warningMessage={warningMessage}
                    setWarningMessage={setWarningMessage}
                />}
            </div>
            {loadingPage && <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}
            {!loadingPage && <div className='mainDataCntnrPageDiv scrollBlue_thick'>
                <div className='2xl:w-[60%] w-[80%] mx-auto bg-blue-50 mb-4 border border-[#c2dcef]'>
                    <div className='  p-3 rounded'>
                        <div className='w-[60%]'>
                            <div className='flex'>
                                <div className=' flex items-start'>
                                    <p className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Invoice Type</p>
                                    <div className="relative custom-radioBlue mb-4 flex items-center m-auto ">
                                        <input type="radio" id="fee_head" name="invoice_type" checked={state.invoice_type === "fee"} onClick={() => handleCheckBox("invoice_type", "fee")}/>
                                        <label htmlFor="fee_head" name="invoice_type" className="font-normal text-[#031624] w-full cursor-pointer text-f7">Fee Head</label>
                                    </div>
                                    <div className='p-2'></div>
                                    <div class="relative custom-radioBlue mb-4 flex items-center m-auto">
                                        <input type="radio" id="inventory" name="invoice_type" checked={state.invoice_type === "inventory"} onClick={() => handleCheckBox("invoice_type", "inventory")}/>
                                        <label htmlFor="inventory" name="invoice_type" className="font-normal text-[#031624] w-full cursor-pointer text-f7">Inventory</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='2xl:w-[60%] w-[80%] mx-auto'>
                    <div className='border border-[#D0D5DD] p-3 rounded'>
                        <div className='flex -mx-10'>
                            <div className='w-[50%] px-10'>
                                {!searchParams.get("isFromDirectory") &&
                                    <>
                                        <div className='flex items-center py-2 mb-4'>
                                            <div className=' flex items-center w-full relative'>
                                                <p className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Receiver Type</p>
                                                <div className="relative custom-radioBlue flex items-center ">
                                                    <input type="radio" id="student" name="receiver_type" onChange={() => handleCheckBox("receiver_type", "student")} checked={state.receiver_type === "student"} />
                                                    <label htmlFor="student" name="receiver_type" className="text-sm font-normal text-[#031624] w-full cursor-pointer">Student</label>
                                                </div>
                                                <div class="relative custom-radioBlue flex items-center ml-2">
                                                    <input type="radio" id="class" name="receiver_type" onChange={() => handleCheckBox("receiver_type", "class")} checked={state.receiver_type === "class"} disabled={searchParams.get("isFromDirectory")} />
                                                    <label htmlFor="class" id='bluk-class' name="receiver_type" className="text-sm font-normal text-[#031624] w-full cursor-pointer">Class</label>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                                {state.receiver_type === "student" ?
                                    <>
                                        <div className='flex'>
                                            <div className=' flex items-center mb-4 w-full relative'>
                                                <label for="date_of_birth" class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Student</label>

                                                <div class="relative w-full" ref={inputRef}>
                                                    {searchParams.get("isFromDirectory") ? <p
                                                        id='student_name'
                                                        className={`text-[#000] rounded block w-full pr-[34px] py-1.5 placeholder:text-f7 placeholder:text-[#818E98] placeholder:font-normal text-f7 font-semibold outline-none error_border`}
                                                    >
                                                        {state?.student_name} [{state.student_id}]
                                                    </p> : <>
                                                        <input 
                                                            type="text" 
                                                            id='student_name'
                                                            title={selectedSearchStudent}
                                                            className={`border ${submitSelected && state.student_name === "" ? "redBorder" : "border-[#D0D5DD]"} w-full slct-inpt-fld`}
                                                            style={{'padding-right':'35px'}}
                                                            placeholder="Search by Student Name / ID" 
                                                            onChange={event=>{setSelectedSearchStudent(event.target.value); handleStudentSearchParams(event.target.value, 'student')}}
                                                            value={selectedSearchStudent}
                                                            autoComplete="off" />
                                                        <button class="absolute top-[50%] -translate-y-[50%] right-2">
                                                            <img loading="lazy" decoding="async" src="/images/search.svg" alt="img" onClick={() => handleStudentSearch(selectedSearchStudent, 'student')}/>
                                                        </button>
                                                        {studentSearchStarted && (
                                                            <ul className="slct_drp_dwn min-w-full select_student" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                                                                <li className="max-h-[150px] overflow-auto scroll-bar">
                                                                    {showStudentsDropdownData ? (
                                                                        studentDropdownData?.length === 0 ? (
                                                                            <ul>
                                                                                <li>
                                                                                    <a
                                                                                        onClick={() => { }}
                                                                                        className="selected_Class"
                                                                                        href="#"
                                                                                        data-te-dropdown-item-ref
                                                                                    >
                                                                                        - No student found / Insufficient AY Details -
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        ) : (
                                                                            studentDropdownData?.map((student) => (
                                                                                <ul key={student.student_id}>
                                                                                    <li>
                                                                                        <a
                                                                                            onClick={async () => {
                                                                                                handleCheckBox('student_uuid', student._id)
                                                                                                handleCheckBox("student_name",student.full_name);
                                                                                                handleCheckBox("student_id",student.student_id);
                                                                                                setStudentDoa(student.date_of_admission);
                                                                                                setSelectedSearchStudent(`${student?.full_name} (${student?.student_id})`);
                                                                                                setStudentDropdownData([]);
                                                                                                setShowStudentDropdownData(false);
                                                                                                setShowClassStudentDropdownData(false);
                                                                                                setStudentSearchStarted(false);
                                                                                                setState((prev) => ({
                                                                                                    ...prev,
                                                                                                    academic_year: {
                                                                                                        name: "",
                                                                                                        start_date: "",
                                                                                                        end_date: "",
                                                                                                    },
                                                                                                    class: "",
                                                                                                    class_id: "",
                                                                                                    sections: "",
                                                                                                    section_id: "",
                                                                                                }));

                                                                                                if (selectedInvoiceDateRef.current) {
                                                                                                    await handleSelectedDate(
                                                                                                        "grn_date",
                                                                                                        dayjs(selectedInvoiceDateRef.current, "YYYY-MM-DD"),
                                                                                                        selectedInvoiceDateRef.current,
                                                                                                        {
                                                                                                            studentUuid: student._id,
                                                                                                            studentId: student.student_id,
                                                                                                            doa: student.date_of_admission,
                                                                                                        }
                                                                                                    );
                                                                                                }
                                                                                            }}
                                                                                            title={`${student?.full_name} (${student?.student_id})`}
                                                                                            className="selected_Class"
                                                                                            href="#"
                                                                                            data-te-dropdown-item-ref
                                                                                        >
                                                                                            {`${student?.full_name} (${student?.student_id})`}
                                                                                        </a>
                                                                                    </li>
                                                                                </ul>
                                                                            ))
                                                                        )
                                                                    ) : (
                                                                        <li className="max-h-[150px] overflow-auto scroll-bar" style={{'padding':'0.3rem 0.5rem'}}>
                                                                            <p className="text-2xl font-bold text-[#031624] mb-4 mt-4"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                                                                        </li>
                                                                    )}
                                                                </li>
                                                            </ul>
                                                        )}</>
                                                        
                                                    }
                                                    
                                                    
                                                    

                                                </div>
                                            </div>
                                        </div>
                                        <div className='flex'>
                                            <div className='relative flex items-center w-full'>
                                                <label for="date_of_birth" class={`text-f7 font-normal text-[#031624] min-w-[130px] inline-flex`}>Academic Year</label>
                                                <input 
                                                    type="text" 
                                                    disabled
                                                    id="academic_year"
                                                    value={state.academic_year.name ? `${state.academic_year.name}, ${state.class}, ${state.sections}`: ""}
                                                    title={state.academic_year.name ? `${state.academic_year.name}, ${state.class}, ${state.sections}`: ""}
                                                    placeholder={"Academic Year"}
                                                    className={`border bg-[#E6E8EA]  ${submitSelected && state.academic_year.name === "" ? "redBorder" : ""} inpt-fld w-full error_border`}
                                                />
                                            </div>
                                        </div>
                                    </>                                    :
                                    <>
                                        <div className='flex'>
                                            <div className=' flex items-center mb-4 w-full relative'>
                                                <label for="date_of_birth" class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Academic Year</label>
                                                <FeeStructureDropdown
                                                    dropDownName={"academic_year"}
                                                    id = {"name"}
                                                    test_id = {"year_name"}
                                                    divClassName={"relative w-full"}
                                                    value={state.academic_year.name === "" ? ""  : `${state.academic_year?.name} (${formatAdjustedDate(state?.academic_year?.start_date)}-${formatAdjustedDate(state?.academic_year?.end_date)}) `}
                                                    placeHolder={"Select Year"}
                                                    showErrorBorder={submitSelected && state.academic_year?.name === ""}
                                                    isMandatoryField={true}
                                                    options={academicYear}
                                                    handleOnchangeInput={handleOnchangeInput}
                                                    outSideClickTriggered={outSideClickTriggered}
                                                    tooltip={true}
                                                    loading={academicLoading}/>
                                                    
                                            </div>
                                        </div>

                                        <div className="flex items-center w-full mb-[16px]">
                                            <label className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Class</label>
                                            <FeeStructureDropdown
                                                dropDownName={"class_name"}
                                                divClassName={`relative w-full`}
                                                value={state.class === "" ? "" : state.class}
                                                placeHolder={"Select Class"}
                                                showErrorBorder={submitSelected && state.class === ""}
                                                options={classes}
                                                handleOnchangeInput={handleOnchangeInput}
                                                tooltip={true}
                                                loading={ classLoading} />
                                        </div>

                                        <div className='flex'>
                                            <div className=' flex items-center w-full relative'>
                                                <label for="date_of_birth" class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Section</label>
                                                <FeeStructureDropdown
                                                    dropDownName={"section"}
                                                    value={state.sections}
                                                    divClassName={"relative w-full"}
                                                    buttonDisabled={state.academic_year.name === "" || state.class === ""}
                                                    applyBGForDisabled={true}
                                                    placeHolder={"Select Section"}
                                                    options={sections}
                                                    handleOnchangeInput={handleOnchangeInput}
                                                    outSideClickTriggered={outSideClickTriggered}
                                                    loading={sectionLoading}

                                                />
                                            </div>
                                        </div>
                                    </>}
                            </div>
                            <div className='w-[50%] px-10'>
                                <div className='flex'>
                                    <div className='relative flex items-center mb-4 w-full'>
                                        <label for="po_date" class={`text-f7 font-normal text-[#031624] min-w-[120px] inline-flex`}>Invoice Date</label>
                                        <div class="relative w-full">
                                            <div className="relative w-full cursor-pointer">
                                                <CustomeDatePicker
                                                    setToastErrorMessage={setToastErrorMessage}
                                                    setsubmitSelected={setsubmitSelected}
                                                    id='grn_date'
                                                    showErrorBorder={(submitSelected && (state.grn_date === "" || state.grn_date === null))}
                                                    isMandatoryField={true}
                                                    format="MMM DD, YYYY"
                                                    state={state}
                                                    placeholder="Select Invoice Date"
                                                    imageClass={true}
                                                    setdateError={setdateError}
                                                    handleSelect={handleInvoiceDateSelection}
                                                    disabledFutureDate={disabledFutureDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='relative flex items-center mb-4 w-full'>
                                        <label for="date_of_birth" class={`text-f7 font-normal text-[#031624] min-w-[120px] inline-flex`}>Invoice Name</label>
                                        <Input
                                            type="text"
                                            id="invoice_name"
                                            state={state}
                                            placeholder={"Invoice Name"}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            maxLength={30}
                                            handleInput={handleInput}
                                        />
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='flex items-center w-full'>
                                        <label
                                            htmlFor='item_code'
                                            className='text-f7 font-normal text-[#031624] min-w-[120px] inline-flex'
                                        >
                                            Financial Year
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="financial_year"
                                            maxLength={30}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Financial Year"}
                                            placeholder={"Financial Year"}
                                            disable={true}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                </div>
                                {state.receiver_type !== "student" && state.academic_year.name !== "" && state.class !== "" && (
                                    <div className='flex mt-4'>
                                        {studentListLoading ? (
                                            <p className="text-2xl font-bold text-[#031624] mb-1">
                                                <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[240px]" />
                                            </p>
                                        ) : (
                                            <div className='flex items-center mb-4 w-full'>
                                                <p
                                                    htmlFor='item_code'
                                                    className={`text-f7 font-normal text-[#106EB4] inline-flex ${studentAllData?.length !== 0 ? 'cursor-pointer' : ''}`}
                                                    onClick={() => studentAllData?.length !== 0 && setViewStudentList(true)}
                                                >
                                                    {studentAllData?.length !== 0
                                                        ? (`Invoice will be issued to ${studentIdArray?.length} student${studentIdArray?.length > 1 ? 's' : ''}`)
                                                        : 'No Students available in the selected Class/Section'}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                )}

                            </div>
                        </div>

                    </div>
                </div>
                {state.invoice_type === "fee" ?
                    <div className='mb-4 w-[55%] mx-auto border border-[#E6E8EA]' style={{'margin-top':'45px'}}>
                        <div className='flex items-center'>
                            <div className='flex items-center p-2 pb-[7px] border-b border-[#E6E8EA] w-[100%]' style={{'background-color': '#f1f1f1'}}>
                                <div className='w-[50%] px-2 font-semibold'>Fee Head</div>
                                <div className='w-[30%] px-2 font-semibold text-end'>Amount</div>
                                <div className='w-[20%]'></div>
                            </div>
                        </div>

                        {feeHeadRows.map((row, idx) => (
                            <div className='flex items-center' key={idx}>
                                <div className='flex items-center mt-[10px] pb-[10px] border-b border-[#E6E8EA] w-[100%]' >
                                    <div className='w-[50%] px-2'>
                                        <DropDownComponent
                                            divClassName={'relative w-full'}
                                            showErrorBorder={submitSelected && row.fee_head_name === ""}
                                            options={feeHeadList}
                                            dropdownkey={"fee_head_name"}
                                            studentDetails={row}
                                            submitSelected={submitSelected}
                                            handleDropDownValue={(key, value) => {
                                                // Check for duplicate fee head selection
                                                const isDuplicate = feeHeadRows.some(
                                                    (item, i) => item.fee_head_id === value._id && i !== idx
                                                );
                                                if (isDuplicate) {
                                                    setToastErrorMessage(`Fee Head '${value.name}' is already selected`);
                                                    return;
                                                }
                                                setToastErrorMessage("");
                                                const updated = [...feeHeadRows];
                                                updated[idx].fee_head_name = value.name;
                                                updated[idx].fee_head_id = value._id;
                                                setFeeHeadRows(updated);
                                            }}
                                            showDropdown={showDropdown}
                                            handleDropdown={handleDropdown}
                                            placeholder={"Select Fee Head"}
                                            selectedvalue={row.fee_head_name}
                                            stateStatus={feeHeadList?.length === 0}
                                            obj={"name"}
                                            outSideClickTriggered={outSideClickTriggered}
                                        />
                                    </div>
                                    <div className='w-[30%] px-2'>
                                        <input
                                            type="text"
                                            className={`bg-[#FFFFFF] border ${submitSelected && row.amount === "" ? "border-[#F04438]" : "border-[#D0D5DD]"} text-end rounded w-full px-3 py-1.5 text-f7 font-normal text-[#101828]`}
                                            placeholder={`0.00`}
                                            value={row.amount}
                                            onChange={(e) => { handleFeeAmountChange(idx, 'fee_amount', e.target.value)}}
                                            maxLength={13}
                                            id={`fee_amount${idx}`}
                                            onFocus={clearIfValueIsZero(idx,'fee_amount')}
                                            onBlur={setZeroIfEmpty(idx,'fee_amount')}
                                        />
                                    </div>
                                    <div className='w-[12%] flex items-center'>
                                        {feeHeadRows.length > 1 && (

                                            <div className='group relative z-[10]'>
                                                <img
                                                    src="/images/delete-bg-red-icon.svg"
                                                    alt="icon"
                                                    className="ml-6 cursor-pointer delete-icon"
                                                    onClick={() => setFeeHeadRows(feeHeadRows.filter((_, i) => i !== idx))}
                                                />
                                                <span class="absolute top-7 left-[-3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>
                                            </div>
                                        )}
                                        
                                        {idx === feeHeadRows.length - 1 && feeHeadRows.length < 20 && 
                                        <div className='group relative z-[10]'>
                                            <img
                                                src="/images/add-icon-blue.svg"
                                                id="plus_iconn"
                                                alt="icon"
                                                className="ml-4 cursor-pointer add-icon"
                                                onClick={() => setFeeHeadRows([...feeHeadRows, feeHeadFields])}
                                            />
                                            <span class="absolute top-7 left-[7px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Add</span>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                        <div className='flex items-center py-2 w-[77.5%]'>
                            <p className='text-lg font-semibold text-black w-[100%] justify-end inline-flex'>
                                <span className='w-[41%] justify-end inline-flex mr-[10px]'>Invoice Total</span>
                                <span className='min-w-[36%] justify-end inline-flex'>{feeHeadRows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0).toFixed(2)}</span>
                            </p>
                        </div>

                    </div>
                    :
                    <div className='mb-4 2xl:w-[90%] w-[99%] mx-auto border border-[#E6E8EA]' style={{'margin-top':'45px'}}>
                        <div className='flex items-center '>
                            <div className={`flex items-center p-2 pb-[7px] border-b border-[#E6E8EA] ${newStateFields?.length === 1 ? "w-[100%]" : "w-[100%]"} `} style={{'background-color': '#f1f1f1'}}>
                                <div className='px-2 w-[21%]'>
                                    <p className='w-full text-f7 font-semibold text-[#031624] mr-4'>Item Name</p>
                                </div>
                                <div className='px-2 w-[16%]'>
                                    <p className='w-full text-f7 font-semibold text-[#031624]'>Item Code</p>
                                </div>
                                <div className='px-2 w-[13%]'>
                                    <p className='w-full text-f7 font-semibold text-[#031624]'>UoM</p>
                                </div>
                                {/* Ledger Field is removed therefore it is commented. */}
                                {/* <div className='px-2 w-[14%]'>
                                    <p className='w-full text-f7 font-semibold text-[#031624]'>Ledger</p>
                                </div>                             */}
                                <div className='px-2 w-[11%]'>
                                    <p className='w-full text-f7 font-semibold text-[#031624]'>Stock Qty</p>
                                </div>
                                <div className='px-2 w-[10%]'>
                                    <p className='w-full text-f7 font-semibold text-[#031624]'>Issue Qty</p>
                                </div>
                                <div className='pl-2 w-[13%]'>
                                    <p className='w-full text-f7 font-semibold text-[#031624] text-right pr-2'>Price / Item</p>
                                </div>
                                <div className='pl-2 w-[14%]'>
                                    <p className='w-full text-f7 font-semibold text-[#031624] text-right pr-2'>Total Price</p>
                                </div>

                                <div className={`${newStateFields?.length === 1 ? "w-[7%]" : "w-[7%]"} `}>
                                </div>
                            </div>
                        </div>
                        {newStateFields.map((field, index = 0) => (
                            <div className='flex items-center' key={index+"ponumber"}>
                                <div className={`flex items-center mt-[10px] pb-[10px] border-b border-[#E6E8EA] ${newStateFields?.length === 1 ? "w-[100%]" : "w-[100%]"} `}>
                                    <SearchItemField
                                        handleSearchFiled={handleSearchFiled}
                                        index={index}
                                        setNewStateFields={setNewStateFields}
                                        newStateFields={newStateFields}
                                        submitSelected={submitSelected}
                                        selectedErrorState={selectedErrorState}
                                        setSelectedErrorState={setSelectedErrorState}
                                        setToastErrorMessage={setToastErrorMessage}
                                        divClassName={"w-[21%] px-2"}
                                        invoices={true}
                                        endPointSearch={"&invoice=true"}
                                        placeHolderValue = "Search by Name/Code"
                                        ShimmerTitle={ShimmerTitle}
                                        noItemMsg = {`No Item found`}
                                    />
                                    <div className='w-[16%] px-2'>
                                        <div className='w-full'>
                                            <input
                                                type="text"
                                                // onBlur={onBlur}
                                                autoComplete='off'
                                                id={`item_code${index}`}
                                                maxLength={30}
                                                className={`${submitSelected && field.item_code === "" ? "redBorder" : ""} inpt-fld w-full error_border`}
                                                placeholder={``}
                                                value={field.item_code}
                                                disabled
                                            // onChange={(e) => {setSelectedInput(index); handleClassFieldChange(index, 'name', e.target.value)}}
                                            />
                                        </div> 
                                    </div>
                                    <div className='w-[13%] px-2'>
                                        <div className='w-full'>
                                            <input
                                                type="text"
                                                // onBlur={onBlur}
                                                autoComplete='off'
                                                id={`uom${index}`}
                                                maxLength={30}
                                                className={`${submitSelected && field.uom === "" ? "redBorder" : "border-[#D0D5DD]"} inpt-fld w-full error_border`}
                                                placeholder={``}
                                                value={field.uom}
                                                disabled
                                            // onChange={(e) => {setSelectedInput(index); handleClassFieldChange(index, 'name', e.target.value)}}
                                            />  
                                        </div>   
                                    </div>
                                    {/* Ledger Field is removed therefore it is commented. */}
                                    {/* <div className='w-[14%] px-2'>
                                        <div className='w-full'>
                                            <DropDownComponent
                                                divClassName={'relative w-full'}  
                                                className={`w-full border ${submitSelected && (field.ledger === "" || field.ledger === undefined)? 'border-[#F04438]' : 'border-[#D0D5DD]'} rounded py-1.5 px-3.5 outline-0 text-f7 text-[#031624] text-left font-normal transition duration-150 ease-in-out error_border`}
                                                options={ledgerList}
                                                dropdownkey={"ledger"}
                                                studentDetails={state}
                                                submitSelected={submitSelected}
                                                handleDropDownValue={handleDropDownValue}
                                                showDropdown={showDropdown}
                                                handleDropdown={handleDropdown}
                                                placeholder={"Select Ledger"}
                                                selectedvalue={field.ledger}
                                                stateStatus={ledgerList?.length === 0 ? true : false}
                                                index={index}
                                            />     
                                        </div>   
                                    </div> */}
                                    <div className='w-[10%] px-2'>
                                        <div className='w-full'>
                                            <input
                                                type="text"
                                                // onBlur={onBlur}
                                                autoComplete='off'
                                                id={`po_quantity${index}`}
                                                maxLength={30}
                                                className={`${submitSelected && field.po_quantity === "" ? "redBorder" : ""} inpt-fld w-full error_border`}
                                                placeholder={``}
                                                value={field.po_quantity}
                                                disabled
                                            />  
                                        </div>   
                                    </div>
                                    <div className='w-[10%] px-2'>
                                        <div className='w-full'>
                                    
                                            <input
                                                type="text"
                                                // onBlur={onBlur}
                                                autoComplete='off'
                                                id={`rcvd_quantity${index}`}
                                                maxLength={13}
                                                className={`${submitSelected && (field.rcvd_quantity === "" || field.rcvd_quantity === undefined || (qtyError && Number(field.rcvd_quantity) > Number(field.po_quantity))) ? "redBorder" : ""} w-full inpt-fld error_border`}
                                                placeholder={`1`}
                                                value={field.rcvd_quantity}
                                                onChange={(e) => { handleFieldChange(index, 'rcvd_quantity', e.target.value)}}
                                            />  
                                        </div>   
                                    </div>
                                    <div className='w-[13%] px-2'>
                                        <div className='w-full'>
                                            <input
                                                type="text"
                                                // onBlur={onBlur}
                                                autoComplete='off'
                                                id={`cost_per_item${index}`}
                                                disabled
                                                maxLength={13}
                                                className={`${submitSelected && (field.cost_per_item === "" || field.cost_per_item === undefined) ? "redBorder" : ""} text-end inpt-fld w-full error_border`}
                                                placeholder={`0.00`}
                                                value={parseFloat((field.cost_per_item===''?0:field.cost_per_item)).toFixed(2)}
                                                onChange={(e) => { handleFieldChange(index, 'cost_per_item', e.target.value)}}
                                            />  
                                        </div>   
                                    </div>
                                    <div className='w-[14%] px-2'>
                                        <div className='w-full relative'>
                                            <input
                                                type="text"
                                                // onBlur={onBlur}
                                                autoComplete='off'
                                                id={`total_cost${index}`}
                                                maxLength={30}
                                                className={`text-end ${submitSelected && (field.total_cost === "") ? "redBorder" : ""} crncy-inpt-fld w-full text-end error_border`}
                                                placeholder={`0.00`}
                                                value={parseFloat((field.total_cost===''?0:field.total_cost)).toFixed(2)}
                                                disabled
                                            // onChange={(e) => {setSelectedInput(index); handleClassFieldChange(index, 'name', e.target.value)}}
                                            />   
                                            <p
                                                alt="icon"
                                                class="absolute top-[50%] -translate-y-[50%] left-[13px] text-f7 text-normal text-[#818E98]"
                                            >
                                                {" "}
                                            </p>
                                        </div>   
                                    </div>

                                    <div class={`${newStateFields?.length === 1 ? "w-[7%]" : "w-[7%]"} flex items-center`}>
                                        {index === newStateFields?.length - 1 ? (
                                            <>
                                                {index !== 0 && (
                                                    <div className='group relative z-[10]'>
                                                        <img
                                                            src="/images/delete-bg-red-icon.svg"
                                                            alt="icon"
                                                            className="ml-2 cursor-pointer delete-icon"
                                                            onClick={() => handleRemoveClassField(index)}
                                                        />
                                                        <span class="absolute top-7 left-[-3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>

                                                    </div>
                                                )}
                                                {index !== 19 && <div className='group relative z-[10]'>
                                                    <img
                                                        src="/images/add-icon-blue.svg"
                                                        id = "plus_iconn"
                                                        alt="icon"
                                                        className="ml-2 cursor-pointer add-icon"
                                                        onClick={() => handleAddClassField()} />
                                                    <span class="absolute top-7 left-[7px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Add</span>
                                                </div>}
                                            </>
                                        ) : (
                                            <div className='group relative z-[10]'>
                                                <img
                                                    src="/images/delete-bg-red-icon.svg"
                                                    alt="icon"
                                                    className="ml-2 cursor-pointer delete-icon"
                                                    onClick={() => handleRemoveClassField(index)}
                                                />
                                                <span class="absolute top-7 left-[-3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>

                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>))}
                        <div className='flex items-center py-2 w-[91.5%]'>
                            <p className='text-lg font-semibold text-black w-[100%] justify-end inline-flex'>
                                <span className='w-[21%] justify-end inline-flex mr-[10px]'>Invoice Total</span>
                                <span className='min-w-[13%] justify-end inline-flex'>{newStateFields.reduce((acc, item) => acc + (parseFloat(item.total_cost) || 0), 0).toFixed(2)}</span>
                            </p>
                        </div>
                    
                    </div>}
            </div>}

            {openConfirmation && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleSubmit}
                        handleClose={() => setOpenConfirmation(false)}
                        crossMark
                        additionalMessage={`An Invoice is being issued for '${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})', which appears to be a back-dated entry.`}
                        message = {`Do you want to continue?`}
                        buttonName = {`Continue`}
                        tittle={'Back Dated Entry'}
                        dialogueWidth={'500px'}
                        textPosition={'text-start'}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
            {bulkIssuePopUp &&
                <AnimatedModel
                    Children={
                        <ConfirmationModel
                            handleOnCLickActivate={()=>{}}
                            handleClose={() => {
                                navigate(type === "student-master" ? '/student-master/invoice-list' : "/inventory-master/inventory-list"); 
                                setBulkIssuePopUp(false) 
                            }}
                            ignoreOutsideClick={true}
                            message={`Bulk invoice processing has begun and is currently in progress. This may take some time.`}
                            buttonName={`OK`}
                            loadingActivation={false}
                        />
                    }
                />
            }
            {viewStudentList && <StudentListPopup 
                setViewStudentList={setViewStudentList} 
                studentAllData={studentAllData} 
                studentIdArray={studentIdArray}
                setStudentIdArray={setStudentIdArray}
                setStudentAllData={setStudentAllData}
                setToastErrorMessage={setToastErrorMessage}
            />}
            {invoiceErrorModalOpen && (
                <InvoiceErrorModal
                    open={invoiceErrorModalOpen}
                    onClose={() => setInvoiceErrorModalOpen(false)}
                    errorList={invoiceErrorList}
                    remainingCount={remainingCount}
                    setIsUnique= {setIsUnique}
                    onProceed={() => {
                        handleSubmit();
                        setInvoiceErrorModalOpen(false);
                        // setInvoiceScheduledModalOpen(true);
                    }}
                />
            )}
        </CardHeader>
    )
}
